import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 13/16;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 16 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.564 3.125l-1.72-1.72a.75.75 0 0 1 1.061-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06-1.06l1.72-1.72H5.37a2.999 2.999 0 0 0-2.996 3v3.747a.75.75 0 1 1-1.5 0V7.625c0-2.485 2.013-4.5 4.496-4.5h7.193z" fill={color} fillRule="evenodd" />
    </svg>
)

export default class IconRoadmap extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
